// @flow

import React, {Component} from 'react';
import Icon, {Icons, Sizes} from '@pb/kit-component-icon';
import {withCssModule} from '@pb/kit-util-with-css-module';
import {Type, Direction} from '../constants';

import styles from './more-less-button.component.module.styl';

const classNames = withCssModule(styles);

/**
 * @component
 * @name MoreLessButton
 * @file
 Use component for more/less functionality.
 */

/**
 * MoreLessButton Props
 */
type Props = {|
    /**
     * Set component to collapse state
     */
    isCollapsed: boolean,
    /**
     * Set component to show button arrows state
     */
    showArrows: boolean,
    /**
     * Text name of "more" button
     */
    moreText: string,
    /**
     * Text name of "less" button
     */
    lessText: string,
    /**
     * Call when click more/less button
     */
    onChange: () => void,
    /**
     * Direction relative to content
     */
    direction: $Keys<typeof Direction>,
    /**
     * Type of content
     */
    type: $Keys<typeof Type>,
    /**
     * Mixed class
     */
    mix: string,
|};

export class MoreLessButton extends Component<Props> {
    static defaultProps = {
        showArrows: true,
        moreText: 'More',
        lessText: 'Less',
        type: Type.TEXT,
        direction: Direction.HORIZONTAL,
        mix: ''
    };

    render() {
        const {
            isCollapsed,
            showArrows,
            moreText,
            lessText,
            onChange,
            type,
            direction,
            mix
        } = this.props;

        const isHorizontalDirection = direction === Direction.HORIZONTAL;

        const buttonClasses = classNames('more-less-button', {
            [mix]: mix,
            'more-less-button_horizontal': isHorizontalDirection,
            'more-less-button_vertical': !isHorizontalDirection
        });

        const textClasses = classNames('more-less-button__caption', {
            'more-less-button__caption_less': !isCollapsed && isHorizontalDirection,
            'more-less-button__caption_text': type === Type.TEXT
        });

        return (
            <a className={buttonClasses} onClick={onChange}>
                {!isCollapsed && showArrows && isHorizontalDirection
                    ? <Icon type={Icons.ANGLE_LEFT} size={Sizes.Size_12}/>
                    : null}

                <span className={textClasses}>
                    {isCollapsed ? moreText : lessText}
                </span>

                {isCollapsed && showArrows && isHorizontalDirection
                    ? <Icon type={Icons.ANGLE_RIGHT} size={Sizes.Size_12}/>
                    : null}

                {showArrows && !isHorizontalDirection
                    ? <Icon type={isCollapsed ? Icons.ANGLE_DOWN : Icons.ANGLE_UP} size={Sizes.Size_12}/>
                    : null}
            </a>
        );
    }
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
